import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'deployment',
    content: {
      root: {
        elements: [
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'deployment.placeholder',
                        },
                      },
                    },
                    span: 12,
                  },
                ],
              },
            },
            height: 300,
          },
        ],
      },
    },
    description: 'Deployment tracking. Not yet implemented.',
    name: 'Deployment',
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
